import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface ISideBar {
  isOpen: boolean;
}
const initialState: ISideBar = {
  isOpen: false,
};
export const sideBarControler = createSlice({
  name: 'sideBarControler',
  initialState,
  reducers: {
    toggleSideBar: (state, action: PayloadAction<ISideBar>) => {
      state.isOpen = action.payload.isOpen;
    },
  },
});

export const {toggleSideBar} = sideBarControler.actions;

export default sideBarControler.reducer;
